module.exports = __webpack_public_path__ + "img/message.9d5c9d14.png";